import { styled } from '../../hooks/theme';

export const ToastContainer = styled.div`
  position: fixed;
  right: 0;
  top: 0;
  overflow: hidden;
  overflow-y: scroll;
  z-index: 9999;
`;
